// extracted by mini-css-extract-plugin
export default {"iconStyle":"Home_iconStyle__kEB+G","tableStyle":"Home_tableStyle__Weo5m"};